import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouteReuseStrategy as AngularRouteReuseStrategy,
} from '@angular/router';
import { isEqual } from 'lodash';

@Injectable()
export class RouteReuseStrategy implements AngularRouteReuseStrategy {
  retrieve(): null {
    return null;
  }

  shouldAttach() {
    return false;
  }

  shouldDetach() {
    return false;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot,
  ) {
    return (
      future.routeConfig === current.routeConfig &&
      (isEqual(future.params, current.params) || current.data.reuse !== false)
    );
  }

  store() {}
}
